import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=5993bfde&scoped=true&"
import script from "./NavLink.vue?vue&type=script&lang=js&"
export * from "./NavLink.vue?vue&type=script&lang=js&"
import style0 from "./NavLink.vue?vue&type=style&index=0&id=5993bfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5993bfde",
  null
  
)

export default component.exports